import { User } from "~/common/Store/models/User";
import getLowestDisplayPrice, {
  PricingGroupMember,
} from "~/common/Product/getLowestDisplayPrice";

const getLowestPriceGroupMember = (
  groupMembers: PricingGroupMember[],
  user: User,
) => {
  // lowestPriceGroupMember will always have a value because we are checking for it in the consuming component.

  let lowestPriceGroupMember = groupMembers[0]!;
  let lowestPrice = Infinity;

  if (groupMembers.length > 1) {
    groupMembers.forEach((member) => {
      const {
        price,
        showBelowMinimumAdvertisedPriceForLoggedInCustomers,
        showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
      } = member;

      const memberPrice = getLowestDisplayPrice(
        {
          showBelowMinimumAdvertisedPriceForLoggedInCustomers:
            showBelowMinimumAdvertisedPriceForLoggedInCustomers,
          showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers:
            showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
          startBuy: member.startBuy,
          price: price,
        },
        user,
      );

      if (memberPrice < lowestPrice) {
        lowestPrice = memberPrice;
        lowestPriceGroupMember = member;
      }
    });
  }
  return lowestPriceGroupMember;
};

export default getLowestPriceGroupMember;
